import React from "react";
import { PostsTab } from "./tabs/PostsTab";
import { useSelector } from "react-redux";
import { BsMailbox2 } from "react-icons/bs";
import { FaUserCheck } from "react-icons/fa";
import { FollowersTab } from "./tabs/FollowersTab";
import { FollowingTab } from "./tabs/FollowingTab";
import { FaUserGroup } from "react-icons/fa6";
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";

export default function AccountTabModal({ setActiveTab, activeTab, otherUserAccount_id, postsTabScrollRef }) {
    const ProfileDetails = useSelector((state) => state.AccountProfile);

    const {
        User_profile,
        User_followingList,
        User_followersList,
        User_posts,
        otherUser_profile,
    } = ProfileDetails;

    const data = [
        {
            label: "Followers",
            value: "followers",
            icon: FaUserGroup,
            desc: <FollowersTab
                datalist={User_followersList}
                otheruser_id={otherUserAccount_id}
            />,
        },
        {
            label: "Following",
            value: "followings",
            icon: FaUserCheck,
            desc: <FollowingTab
                datalist={User_followingList}
                otheruser_id={otherUserAccount_id}
            />,
        },
        {
            label: "Posts",
            value: "posts",
            icon: BsMailbox2,
            desc: <PostsTab
                activeTab={activeTab}
                User_posts={User_posts}
                User_profile={User_profile}
                otheruser_id={otherUserAccount_id}
                postsTabScrollRef={postsTabScrollRef}
            />,
        },
    ];

    const filterOtherUserAccount = () => {
        if (otherUserAccount_id) {
            return data.filter(item => item.value !== "posts");
        }
        return data;
    }

    return (
        <div className="h-full w-full mb-2">
            <Tabs
                value={activeTab}
                className="absolute h-[-webkit-fill-available] w-full pt-2 z-50 bg-white dark:bg-[#0e0e0e] rounded-md"
            >
                <TabsHeader className="mx-2 dark:bg-gray-800">
                    {filterOtherUserAccount().map(({ label, value, icon }) => (
                        <Tab key={value} value={value}>
                            <div
                                onClick={() => setActiveTab(value)}
                                className="flex items-center dark:text-black gap-2 text-[10px] md:text-[10px] font-bold"
                            >
                                {React.createElement(icon, { className: "w-3 h-3" })}
                                {label}
                            </div>
                        </Tab>
                    ))}
                </TabsHeader>
                <TabsBody className="h-[-webkit-fill-available]">
                    {filterOtherUserAccount().map(({ value, desc }) => (
                        <TabPanel
                            uppercase
                            key={value}
                            value={value}
                            className={`h-[-webkit-fill-available] w-full p-0 mt-2`}
                        >
                            {desc}
                        </TabPanel>
                    ))}
                </TabsBody>
            </Tabs>
        </div>
    );
}
